import { Component } from '@theme/component';

/** @typedef {object} Refs
 * @property {HTMLButtonElement} toggle
 * @property {HTMLElement} conteudo
 * @property {HTMLElement} codigo
 * @property {HTMLButtonElement} copiar
 * @property {HTMLElement} aviso
 */
class PrimeiraCompraPromo extends Component {
  requiredRefs = ['toggle', 'conteudo', 'codigo', 'copiar', 'aviso'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.toggle.addEventListener('click', this.#alternar);
    this.refs.copiar.addEventListener('click', this.#copiar);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.toggle.removeEventListener('click', this.#alternar);
    this.refs.copiar.removeEventListener('click', this.#copiar);
  }

  #alternar = () => {
    const aberto = this.dataset.aberto === 'true';
    this.dataset.aberto = String(!aberto);
    this.refs.toggle.setAttribute('aria-expanded', String(!aberto));
    this.refs.conteudo.hidden = false;
    if (aberto) window.setTimeout(() => { this.refs.conteudo.hidden = true; }, 300);
  };

  #copiar = async () => {
    const codigo = this.refs.codigo.textContent.trim();
    try {
      await navigator.clipboard.writeText(codigo);
      this.refs.aviso.textContent = this.refs.copiar.dataset.mensagemCopiado || 'Código copiado!';
    } catch {
      this.refs.aviso.textContent = 'Não foi possível copiar o código.';
    }
  };
}

if (!customElements.get('primeira-compra-promo')) {
  customElements.define('primeira-compra-promo', PrimeiraCompraPromo);
}
